import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=5ca72ceb&scoped=true&"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=5ca72ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca72ceb",
  null
  
)

export default component.exports